/**
 * Vuex module to filter SMS conversations
 * namespace: /chat/SmsFilters
 * phone number filter still in /chat namespace
 */
import ChatLocalStorage from '@/api/chat'

const actions = {
  filterClosed ({ commit }, closed) {
    commit('SET_CLOSED', closed)
    ChatLocalStorage.setSmsFilterClosed(closed)
  },
  filterRead ({ commit }, read) {
    commit('SET_READ', read)
    ChatLocalStorage.setSmsFilterRead(read)
  },
  setSearch ({ commit }, search) {
    commit('SET_SEARCH', search)
  }
}

const mutations = {
  SET_CLOSED (state, closed) {
    state.closed = closed
  },
  SET_READ (state, read) {
    state.read = read
  },
  SET_SEARCH (state, search) {
    state.search = search
  }
}

const state = {
  closed: true,
  read: false,
  search: ''
}

const getters = {
  closed: state => state.closed,
  read: state => state.read,
  search: state => state.search
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
